import { render, staticRenderFns } from "./DonationReceipt.vue?vue&type=template&id=6adfc902&"
import script from "./DonationReceipt.vue?vue&type=script&lang=js&"
export * from "./DonationReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports